export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('view-inventory'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev vhp:content:view inventory',
							onclickLinkName: '{client}:ev vhp:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('search-inventory'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev vhp:content:search inventory',
							onclickLinkName: '{client}:ev vhp:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('explore-interior'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:explore interior',
							referredTo: 'explore interior',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('explore-exterior'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:explore exterior',
							referredTo: 'explore exterior',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('pro-power'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:pro power onboard',
							referredTo: 'pro power onboard',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('home-backup-power'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:home backup power',
							referredTo: 'home backup power',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('explore-technology'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:explore technology',
							referredTo: 'explore technology',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) =>
					className
						.split(' ')
						.includes('see-how-much-you-could-save'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:see how much you can save',
							referredTo: 'see how much you can save',
							onclickLinkName: 'referral:exit'
						}
					}
				}
			}
		]
	}
};
